import React, { Component } from 'react';

import ManagedComponent from '../components/managed-component';
import { SectionChild } from '../components/section';

import OAuth from './oauth';

class StravaLogin extends Component {
  static _type = 'StravaLogin';
  _type = 'StravaLogin';

  static defaultProps = {
    oauthData: {},
    onAccessToken: () => {}
  };

  onAccessToken = (oauthData) => {
    const { access_token, athlete } = oauthData;
    const { onAccessToken } = this.props;

    if (typeof onAccessToken === 'function') {
      onAccessToken(access_token, athlete, oauthData);
    }
  };

  getStatus() {
    const { oauthData } = this.props;

    if (oauthData.error) {
      return 'Re-authorize';
    }

    if (!oauthData.athlete) {
      return 'Authorize';
    }

    const { username, firstname, lastname } = oauthData.athlete;
    return username || `${firstname} ${lastname}`;
  }

  render() {
    const {
      title,
      description,
      label = 'Strava',
      status = this.getStatus(),
      approvalPrompt,
      clientId,
      clientSecret,
      url = 'https://www.strava.com/oauth/authorize',
      requestTokenUrl = 'https://www.strava.com/oauth/token',
      oauthData,
      scope
    } = this.props;

    return (
      <SectionChild title={title} description={description}>
        <OAuth
          label={label}
          status={status}
          clientId={clientId}
          clientSecret={clientSecret}
          url={url}
          requestTokenUrl={requestTokenUrl}
          scope={scope}
          oAuthParams={{
            approval_prompt: approvalPrompt
          }}
          showError={oauthData.error}
          onAccessToken={this.onAccessToken}
        />
      </SectionChild>
    );
  }
}

export default class extends Component {
  parseValue(rawValue) {
    try {
      return JSON.parse(rawValue);
    } catch (err) {
      return;
    }
  }

  render() {
    const {
      title,
      description,
      label,
      status,
      approvalPrompt,
      clientId,
      clientSecret,
      url,
      requestTokenUrl,
      scope,
      onAccessToken,
      settingsKey
    } = this.props;

    const stravaProps = {
      title,
      description,
      label,
      status,
      approvalPrompt,
      clientId,
      clientSecret,
      url,
      requestTokenUrl,
      scope,
      onAccessToken
    };

    if (!settingsKey) {
      return (
        <StravaLogin {...stravaProps} />
      );
    }

    return (
      <ManagedComponent settingsKey={settingsKey}>
        {({ value, onChange }) => (
          <StravaLogin
            {...stravaProps}
            oauthData={this.parseValue(value)}
            onAccessToken={(access_token, athlete, oauthData) => {
              if (typeof onAccessToken === 'function') {
                onAccessToken(access_token, athlete, oauthData);
              }
              onChange(JSON.stringify(oauthData));
            }}
          />
        )}
      </ManagedComponent>
    );
  }
}



// WEBPACK FOOTER //
// ./src/fitbit-components/strava-login.js